import {CimType} from 'frontend/cimclient/graphql/generated/CimSchema';

import {MapAsset} from './map_asset';
import {BatteryMapMarker} from './map_markers/battery';
import {BreakerMapMarker} from './map_markers/breaker';
import {CapacitorMapMarker} from './map_markers/capacitor';
import {CutMapMarker} from './map_markers/cut';
import {
  AssetMapMarker,
  BusbarMapMarker,
  EquivalentShuntMapMarker,
  FeederMapMarker,
  GeneratingUnitMapMarker,
} from './map_markers/default';
import {DisconnectorMapMarker} from './map_markers/disconnector';
import {FuseMapMarker} from './map_markers/fuse';
import {GeothermalGeneratorMapMarker} from './map_markers/generator_geothermal';
import {HydroGeneratorMapMarker} from './map_markers/generator_hydro';
import {HydroStorageGeneratorMapMarker} from './map_markers/generator_hydro_storage';
import {PVSolarGeneratorMapMarker} from './map_markers/generator_pv_solar';
import {WindGeneratorMapMarker} from './map_markers/generator_wind';
import {ReactorMapMarker} from './map_markers/reactor';
import {RecloserMapMarker} from './map_markers/recloser';
import {SubstationMapMarker} from './map_markers/substation';
import {SwitchMapMarker} from './map_markers/switch';
import {TransformerMapMarker} from './map_markers/transformer';

/**
 * Factory method for generating markers per asset type.
 */
export function assetMapMarkersFactory(asset: MapAsset, highlight: boolean): AssetMapMarker | null {
  if (asset.location.length === 0) {
    return null;
  }

  switch (asset.type) {
    case CimType.BatteryUnit:
      return new BatteryMapMarker(asset, highlight);
    case CimType.Breaker:
      return new BreakerMapMarker(asset, highlight);
    case CimType.BusbarSection:
      return new BusbarMapMarker(asset, highlight);
    case CimType.Cut:
    case CimType.Jumper:
      return new CutMapMarker(asset, highlight);
    case CimType.Disconnector:
    case CimType.GroundDisconnector:
    case CimType.ProtectedSwitch:
      return new DisconnectorMapMarker(asset, highlight);
    case CimType.EquivalentShunt:
      return new EquivalentShuntMapMarker(asset, highlight);
    case CimType.Feeder:
      return new FeederMapMarker(asset, highlight);
    case CimType.Fuse:
      return new FuseMapMarker(asset, highlight);
    case CimType.GeneratingUnit:
      return new GeneratingUnitMapMarker(asset, highlight);
    case CimType.HydroPowerPlant:
      return new HydroGeneratorMapMarker(asset, highlight);
    case CimType.HydroPump:
      return new HydroStorageGeneratorMapMarker(asset, highlight);
    case CimType.Junction:
      return new ReactorMapMarker(asset, highlight);
    case CimType.LinearShuntCompensator:
    case CimType.NonlinearShuntCompensator:
      return new CapacitorMapMarker(asset, highlight);
    case CimType.PhotoVoltaicUnit:
      return new PVSolarGeneratorMapMarker(asset, highlight);
    case CimType.PowerElectronicsWindUnit:
    case CimType.WindGeneratingUnit:
      return new WindGeneratorMapMarker(asset, highlight);
    case CimType.PowerTransformer:
      return new TransformerMapMarker(asset, highlight);
    case CimType.Recloser:
    case CimType.Sectionaliser:
      return new RecloserMapMarker(asset, highlight);
    case CimType.Substation:
      return new SubstationMapMarker(asset, highlight);
    case CimType.Switch:
      return new SwitchMapMarker(asset, highlight);
    case CimType.ThermalGeneratingUnit:
      return new GeothermalGeneratorMapMarker(asset, highlight);
    default:
      return null;
  }
}
